import React from "react";
import Img1 from '../Fitnessimg/icon-1.png';
import Img2 from '../Fitnessimg/icon-6.png';
import Img3 from '../Fitnessimg/fitness-goal-banner.png';
import Img4 from '../Fitnessimg/icon-2.png';

const Fitnessgoal = () => {
    return(
        <div class="container-fluid goal pt-5">
            <div class="container pt-5">
                <div class="row g-5">
                    <div class="col-lg-6 wow fadeInLeft" data-wow-delay="0.2s">
                        <div class="goal-content">
                            <h4 class="text-primary">Fitness Goal</h4>
                            <h1 class="display-4 mb-4">Complete your possibilities, Achieve Your Fitness Goals.</h1>
                            
                            {/* Existing goal items */}
                            <div class="goal-item d-flex p-4">
                                <div class="d-flex me-4">
                                    <div class="bg-primary d-inline p-3" style={{width: "80px" , height: "80px"}}>
                                        <img src={Img1} class="img-fluid" alt=""/>
                                    </div>
                                </div>
                                <div>
                                    <h4>Free Fitness Training</h4>
                                    <p class="text-white mb-0">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Tempore est harum</p>
                                </div>
                            </div>
                            
                            <div class="goal-item d-flex p-4">
                                <div class="d-flex me-4">
                                    <div class="bg-primary d-inline p-3" style={{width: "80px" , height: "80px"}}>
                                        <img src={Img2} class="img-fluid" alt=""/>
                                    </div>
                                </div>
                                <div>
                                    <h4>Cardio and Strength</h4>
                                    <p class="text-white mb-0">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Tempore est harum</p>
                                </div>
                            </div>
                            
                            {/* New Content Categories Section */}
                            <div class="goal-item d-flex p-4">
                                <div class="d-flex me-4">
                                    <div class="bg-primary d-inline p-3" style={{width: "80px" , height: "80px"}}>
                                        <img src={Img4} class="img-fluid" alt=""/>
                                    </div>
                                </div>
                                <div>
                                    <h4>Content Categories</h4>
                                    <div class="text-white mb-0">
                                        <p><strong>Primary Niche:</strong> Fitness & Wellness</p>
                                        <p><strong>Secondary Niche:</strong> Healthy Lifestyle</p>
                                        <p><strong>Content Types:</strong> Tutorial Videos, Progress Photos, Live Q&A</p>
                                        <p><strong>Languages:</strong> English, Spanish (basic)</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="ms-1">
                                <a href="#" class="btn btn-primary py-3 px-5 ms-2"> <span>Read Details</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
                        <div class="h-100">
                            <img src={Img3} class="img-fluid h-100" style={{objectFit: "cover"}} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Fitnessgoal;